<div class="flex flex-row flex-wrap align-items-center gap-3">
  <p-button
    (click)="changeTheme()"
    size="small"
    [raised]="true"
    [text]="true"
    [rounded]="true"
    styleClass="surface-0"
    [icon]="activeTheme === lightTheme ? 'fas fa-moon' : 'fas fa-sun'" />
</div>
